import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** Same pixel width as the desktop drawer; use on `ScrollArea` so it gets a definite width like shadcn’s `w-[350px]` example. */
export const AI_CHAT_SIDEBAR_DRAWER_WIDTH = 'w-[200px]';

interface SidebarDrawerProps {
    isOpen: boolean;
    children: ReactNode;
}

export const SidebarDrawer = ({ isOpen, children }: SidebarDrawerProps) => {
    return (
        <div
            role="region"
            aria-label="Sidebar"
            className={cn(
                'absolute top-0 right-full h-full',
                AI_CHAT_SIDEBAR_DRAWER_WIDTH,
                'transition-[opacity,visibility] duration-100 ease-out',
                'overflow-hidden rounded-tl-xl rounded-bl-xl',
                'bg-secondary-dark light:bg-background dark:bg-background',
                isOpen ? 'visible opacity-100' : 'invisible opacity-0',
            )}
        >
            {children}
        </div>
    );
};
